export enum DashboardLegendType {
    off = 100,
    icon = 200,
    iconlabel = 300,
}

// The string values are i18n keys resolved via the `transloco` pipe at the display site
export const DashboardLegendTypeDescription: { [type in DashboardLegendType]: string } = {
    100: "dashboard.legendType.hide",
    200: "dashboard.legendType.iconOnly",
    300: "dashboard.legendType.iconAndLabel",
};
